export const AUTH_TOKEN_KEY = "auth_token";
export const USER_DATA_KEY = "user_data";

export function dispatchStorageEvent(key, newValue) {
  window.dispatchEvent(
    new CustomEvent("localStorageChange", {
      detail: { key, newValue },
    })
  );
}

export function clearAuthSession({ redirectToLogin = false } = {}) {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(USER_DATA_KEY);
  dispatchStorageEvent(AUTH_TOKEN_KEY, null);

  if (redirectToLogin && !window.location.pathname.includes("/login")) {
    window.location.href = "/login";
  }
}

export function isUnauthorizedError(error) {
  if (error?.response?.status === 401 || error?.statusCode === 401) {
    return true;
  }

  const message = [
    error?.message,
    error?.error?.message,
    error?.toString?.(),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return message.includes("401") || message.includes("unauthorized");
}
